export default __webpack_public_path__ + "static/flipImg1-0c3f0bfa59120004b2ad212006f498cc.webp";